import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { EngagementMetricsQueryParams } from '../types/engagement-metrics.types';

export const engagementMetricsKeys = {
  all: ['analytics', 'engagement-metrics'] as const,
  overview: (params?: EngagementMetricsQueryParams) =>
    [...engagementMetricsKeys.all, 'overview', params] as const,
};

export const useEngagementMetricsData = (
  params?: EngagementMetricsQueryParams,
  enabled = true,
) => {
  return useQuery({
    queryKey: engagementMetricsKeys.overview(params),
    queryFn: async () => {
      const response = await analyticsApi.getEngagementMetrics(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
